import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'cnf-notfound',
    standalone: true,
    imports: [RouterModule, ButtonModule],
    template: `
        <div class="min-h-screen flex justify-center items-center px-8 bg-surface-50 dark:bg-surface-950">
            <div class="card text-center flex flex-col items-center gap-4 max-w-md">
                <i class="pi pi-compass text-primary" style="font-size: 3rem"></i>
                <div class="font-semibold text-2xl">Seite nicht gefunden</div>
                <p class="m-0 text-surface-500 dark:text-surface-400">Die angeforderte Seite existiert nicht oder wurde verschoben.</p>
                <p-button label="Zum Dashboard" icon="pi pi-home" [routerLink]="['/']" />
            </div>
        </div>
    `
})
export class Notfound {}
